<header>
    <div class="sm-header">
        <div class="container">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <a href="https://www.santaluciaam.es/">
                        <img src="assets/images/logo.png" class="logo" alt="Santalucia Asset Management" />
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div class="bg-white">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="info-header" [class.with-back]="showBack" *ngIf="showInfo">
                        <div class="btn-wrapper left">
                            <button
                                type="button"
                                class="btn-back mat-elevation-z0 px-2 pr-md-3"
                                mat-flat-button
                                color="gray"
                                (click)="onBack()"
                                *ngIf="showBack"
                            >
                                <mat-icon>chevron_left</mat-icon>
                                <span class="font-weight-light d-none d-md-inline">{{ 'general.back' | translate }}</span>
                            </button>
                        </div>

                        <div class="row align-items-center user-info" *ngIf="!user">
                            <div class="col-12 mat-subheading-2 my-2 my-md-3">
                                <strong *ngIf="!contract || !contract.isAdvisoryModelSuitabilityOrGDC()">{{
                                    'header.client-registration' | translate
                                }}</strong>
                                <strong *ngIf="contract && contract.isAdvisoryModelSuitability()">{{
                                    'header.new-account-advice' | translate
                                }}</strong>
                                <strong *ngIf="contract && contract.isAdvisoryModelGDC()">{{
                                    'header.new-account-gdc' | translate
                                }}</strong>
                            </div>
                        </div>

                        <div class="row flex-lg-nowrap user-info" *ngIf="user">
                            <div class="col-12 col-lg-auto d-flex flex-nowrap mb-2 mb-lg-0">
                                <div class="user-avatar">
                                    <i class="icon-minor"></i>
                                </div>
                                <div class="user-data flex-shrink-1 flex-grow-1 ml-3">
                                    <strong class="d-block">{{ user.name }} {{ user.surname }}</strong>
                                    <span class="d-block">{{ user.phone ? user.phone : '-' }}</span>
                                    <span class="d-block text-truncate">{{ user.email ? user.email : '-' }}</span>
                                </div>
                            </div>
                            <div class="col-12 col-lg-auto flex-shrink-1 flex-grow-1">
                                <div class="row flex-lg-nowrap">
                                    <div
                                        class="col-lg-auto flex-shrink-1 mb-lg-0"
                                        [class.col-6]="user.mifidCompetenceName"
                                        [class.col-12]="!user.mifidCompetenceName"
                                    >
                                        <span class="d-block"
                                            >{{ 'header.user.document-type' | translate }}:
                                            <strong class="d-block d-sm-inline">{{
                                                user.docType ? ('form.document-types.' + user.docType | translate) : '-'
                                            }}</strong>
                                        </span>
                                        <span class="d-block"
                                            >{{ 'header.user.document' | translate }}:
                                            <strong class="d-block d-sm-inline">{{ user.docId || '-' }}</strong>
                                        </span>
                                        <small class="d-block" *ngIf="user.docExpirationDate"
                                            >({{ 'header.user.valid-until' | translate }}
                                            {{ user.docExpirationDate?.toDate() | date: 'dd-MM-yyyy' }})</small
                                        >
                                        <small class="d-block" *ngIf="!user.docExpirationDate"
                                            >({{ 'header.user.valid-permanent' | translate }})</small
                                        >
                                        <span class="d-block"
                                            >{{ 'header.user.test-result' | translate }}:
                                            <strong class="d-block d-sm-inline">{{
                                                user.mifidCompetenceName ? user.mifidCompetenceName : '-'
                                            }}</strong>
                                        </span>
                                    </div>
                                    <div class="col-6 col-lg-auto flex-shrink-1 flex-grow-1">
                                        <span class="d-block" *ngIf="user.profileId"
                                            >{{ 'header.user.risk-profile' | translate }}:
                                            <strong class="d-block d-sm-inline">{{ user.profileName ? user.profileName : '-' }}</strong>
                                        </span>
                                        <span class="d-block"
                                            >{{ 'header.user.last-test-date' | translate }}:
                                            <strong class="d-block d-sm-inline">{{
                                                user.lastTestDate ? (user.lastTestDate?.toDate() | date: 'dd-MM-yyyy') : '-'
                                            }}</strong>
                                        </span>
                                        <span class="d-block"
                                            >{{ 'header.user.next-test-date' | translate }}:
                                            <strong class="d-block d-sm-inline" *ngIf="user.mifidCategoryCode === MifidCategoryCode.MI">{{
                                                user.nextTestDate ? (user.nextTestDate?.toDate() | date: 'dd-MM-yyyy') : '-'
                                            }}</strong>
                                            <strong class="d-block d-sm-inline" *ngIf="user.mifidCategoryCode !== MifidCategoryCode.MI">{{
                                                'header.user.doesnt-apply' | translate
                                            }}</strong>
                                        </span>
                                        <small
                                            class="d-block"
                                            *ngIf="
                                                user.nextTestDate && user.daysToNextTest && user.mifidCategoryCode === MifidCategoryCode.MI
                                            "
                                        >
                                            ({{
                                                'header.user.days-left'
                                                    | translate
                                                        : {
                                                              days: user.daysToNextTest
                                                          }
                                            }})
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="btn-wrapper right" [ngClass]="{ 'd-none d-md-block': !!user }">
                            <button
                                type="button"
                                class="btn-dictionary mat-elevation-z0"
                                mat-flat-button
                                color="gray"
                                (click)="onDictionary()"
                            >
                                <i class="icon-book mb-md-2"></i>
                                <span class="font-weight-light d-none d-md-inline" [innerHTML]="'header.dictionary' | translate"></span>
                            </button>
                            <button type="button" class="btn-phone mat-elevation-z0" mat-flat-button color="blue" (click)="onPhone()">
                                <i class="icon-phone mb-md-2"></i>
                                <span class="font-weight-light d-none d-md-inline" [innerHTML]="'header.phone-help' | translate"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
